import React, { useState, useEffect } from 'react';
import ShopifyService from '../services/shopifyService';  // 🔥 DOĞRU YOL
import './VendorBulkPriceUpdate.css';

const VendorBulkPriceUpdate = () => {
    const [activeSection, setActiveSection] = useState('type');
    const [priceUpdateType, setPriceUpdateType] = useState('temporary');

    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState('');
    const [vendorProducts, setVendorProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [percentage, setPercentage] = useState('');
    const [newPrice, setNewPrice] = useState('');
    const [changeType, setChangeType] = useState('decrease');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [stepHistory, setStepHistory] = useState(['type']);

    const [activeTab, setActiveTab] = useState('new'); // 'new' veya 'history'
    const [pricePolicies, setPricePolicies] = useState([
        {
            id: 1,
            policyName: "Haftasonu İndirimi",
            vendorName: "Everest",
            percentage: 15.0,
            changeType: "decrease",
            priceType: "TEMPORARY",
            appliedProductIds: [10244728848722, 10244728848723],
            appliedAt: new Date('2024-01-15'),
            isActive: true
        },
        {
            id: 2,
            policyName: "Yılbaşı Zamları",
            vendorName: "Everest",
            percentage: 10.0,
            changeType: "increase",
            priceType: "PERMANENT",
            appliedProductIds: [10244728848724],
            appliedAt: new Date('2024-01-01'),
            isActive: true
        },
        {
            id: 3,
            policyName: "Sezon Sonu İndirimi",
            vendorName: "Everest",
            percentage: 25.0,
            changeType: "decrease",
            priceType: "TEMPORARY",
            appliedProductIds: [10244728848725, 10244728848726, 10244728848727],
            appliedAt: new Date('2023-12-20'),
            isActive: false
        }
    ]);

    ////
    // 🔥 YENİ: Politika geçmişini backend'den yükle
    useEffect(() => {
        if (selectedVendor && activeTab === 'history') {
            loadPricePolicies();
        }
    }, [selectedVendor, activeTab]);

    const loadPricePolicies = async () => {
        try {
            console.log('🔄 Politika geçmişi yükleniyor:', selectedVendor);
            const policies = await ShopifyService.getPricePolicies(selectedVendor);
            setPricePolicies(policies);
            console.log('✅ Politika geçmişi yüklendi:', policies.length, 'politika');
        } catch (error) {
            console.error('❌ Politika geçmişi yükleme hatası:', error);
            // Backend hazır olana kadar boş array
            setPricePolicies([]);
        }
    };
    /////


    useEffect(() => {
        loadVendors();
    }, []);

    const loadVendors = async () => {
        try {
            const result = await ShopifyService.getAllVendors();
            if (result.success) {
                setVendors(result.vendors);
            }
        } catch (error) {
            console.error('Vendor yükleme hatası:', error);
        }
    };

    const handleVendorSelect = async (vendor) => {
        setSelectedVendor(vendor);
        setSelectedProducts([]);

        if (!vendor) return;

        try {
            const result = await ShopifyService.getProductsByVendor(vendor, 'all');
            if (result.success) {
                setVendorProducts(result.products);
                nextStep('products');
            }
        } catch (error) {
            console.error('Ürün getirme hatası:', error);
        }
    };

    const nextStep = (step) => {
        setActiveSection(step);
        setStepHistory(prev => [...prev, step]);
    };

    const prevStep = () => {
        if (stepHistory.length > 1) {
            const newHistory = [...stepHistory];
            newHistory.pop();
            setStepHistory(newHistory);
            setActiveSection(newHistory[newHistory.length - 1]);
        }
    };

    const handleRemovePolicy = async (policyId) => {
        console.log('🗑️ Politika kaldırılıyor:', policyId);

        try {
            const result = await ShopifyService.removePricePolicy(policyId);
            console.log('Politika kaldırma sonucu:', result);

            if (result.success) {
                // Listeyi yenile
                loadPricePolicies();
            }
        } catch (error) {
            console.error('Politika kaldırma hatası:', error);
        }
    };


    // 🔥 BURASI EKSİKTİ - handleApplyChanges FONKSİYONU
    const handleApplyChanges = async () => {
        console.log('🔴 CRITICAL DEBUG: handleApplyChanges BAŞLADI');

        // 🔥 DEĞİŞİKLİK: Variant ID'lerini topla
        const variantIds = [];
        vendorProducts.forEach(product => {
            if (selectedProducts.includes(product.id) && product.variants) {
                product.variants.forEach(variant => {
                    variantIds.push(variant.id);
                });
            }
        });

        console.log('🔴 selectedVendor:', selectedVendor);
        console.log('🔴 selectedProducts (ürün ID):', selectedProducts);
        console.log('🔴 variantIds (variant ID):', variantIds);
        console.log('🔴 Toplam variant sayısı:', variantIds.length);

        setLoading(true);
        setResult(null);

        try {
            let result;
            // 🔥 DEĞİŞİKLİK: productIds yerine variantIds kullan
            const idsToSend = variantIds.length > 0 ? variantIds : null;
            console.log('🔴 Backend\'e gönderilecek variantIds:', idsToSend);

            if (priceUpdateType === 'temporary') {
                console.log('🔴 Geçici fiyat değişikliği çağrılıyor...');
                result = await ShopifyService.applyTemporaryPriceChange(
                    selectedVendor,
                    parseFloat(percentage),
                    changeType,
                    idsToSend  // 🔥 variantIds gönder
                );
            } else {
                console.log('🔴 Kalıcı fiyat değişikliği çağrılıyor...');
                result = await ShopifyService.updatePermanentPrice(
                    selectedVendor,
                    parseFloat(newPrice),
                    idsToSend  // 🔥 variantIds gönder
                );
            }

            console.log('🔴 Service sonucu:', result);
            setResult(result);
            nextStep('result');

        } catch (error) {
            console.error('🔴 HandleApplyChanges hatası:', error);
            setResult({
                success: false,
                message: 'İşlem hatası: ' + error.message
            });
        } finally {
            setLoading(false);
        }
    };

    const handleResetToOriginal = async () => {
        setLoading(true);
        try {
            // 🔥 DEĞİŞİKLİK: Variant ID'lerini topla
            const variantIds = [];
            vendorProducts.forEach(product => {
                if (selectedProducts.includes(product.id) && product.variants) {
                    product.variants.forEach(variant => {
                        variantIds.push(variant.id);
                    });
                }
            });

            console.log('🔴 Reset için variantIds:', variantIds);
            const idsToSend = variantIds.length > 0 ? variantIds : null;

            const result = await ShopifyService.resetToOriginalPrice(selectedVendor, idsToSend);
            setResult(result);
        } catch (error) {
            setResult({
                success: false,
                message: 'Reset hatası: ' + error.message
            });
        } finally {
            setLoading(false);
        }
    };

    const toggleSelectAll = () => {
        if (selectedProducts.length === vendorProducts.length) {
            setSelectedProducts([]);
        } else {
            setSelectedProducts(vendorProducts.map(p => p.id));
        }
    };

    const toggleProductSelection = (productId) => {
        setSelectedProducts(prev =>
            prev.includes(productId)
                ? prev.filter(id => id !== productId)
                : [...prev, productId]
        );
    };

    const renderTypeSelection = () => (
        <div className="step-card">
            <div className="step-header">
                <div className="step-number">1</div>
                <h3>🎯 İşlem Türünü Seçin</h3>
            </div>

            <div className="type-selection">
                <div
                    className={`type-card ${priceUpdateType === 'temporary' ? 'selected' : ''}`}
                    onClick={() => setPriceUpdateType('temporary')}
                >
                    <div className="type-icon">🎪</div>
                    <div className="type-content">
                        <h4>Geçici İndirim/Artış</h4>
                        <p>Yüzde bazlı değişiklik. İstediğin zaman orijinal fiyata dönebilirsin.</p>
                        <ul>
                            <li>✅ Haftasonu indirimleri</li>
                            <li>✅ Kampanya fiyatları</li>
                            <li>✅ Sezonluk değişiklikler</li>
                        </ul>
                    </div>
                </div>

                <div
                    className={`type-card ${priceUpdateType === 'permanent' ? 'selected' : ''}`}
                    onClick={() => setPriceUpdateType('permanent')}
                >
                    <div className="type-icon">💰</div>
                    <div className="type-content">
                        <h4>Kalıcı Fiyat Değişimi</h4>
                        <p>Kalıcı fiyat güncellemesi. Orijinal fiyat değişir.</p>
                        <ul>
                            <li>✅ Yılbaşı zammı</li>
                            <li>✅ Kalıcı fiyat düzenlemesi</li>
                            <li>✅ Maliyet değişiklikleri</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="step-actions">
                <button
                    className="btn-primary"
                    onClick={() => nextStep('vendor')}
                    disabled={!priceUpdateType}
                >
                    Devam Et ➡
                </button>
            </div>
        </div>
    );

    const renderVendorSelection = () => (
        <div className="step-card">
            <div className="step-header">
                <div className="step-number">2</div>
                <h3>🏪 Vendor Seçin</h3>
            </div>

            <div className="form-group">
                <label>Vendor Listesi</label>
                <select
                    value={selectedVendor}
                    onChange={(e) => handleVendorSelect(e.target.value)}
                    className="form-select"
                >
                    <option value="">Vendor seçin...</option>
                    {vendors.map((vendor, index) => (
                        <option key={index} value={vendor}>
                            {vendor}
                        </option>
                    ))}
                </select>
            </div>

            <div className="step-actions">
                <button className="btn-secondary" onClick={prevStep}>
                    ⬅ Geri
                </button>
                <button
                    className="btn-primary"
                    onClick={() => nextStep('products')}
                    disabled={!selectedVendor}
                >
                    Devam Et ➡
                </button>
            </div>
        </div>
    );


    //
    const renderPolicyHistory = () => (
        <div className="policy-history">
            <h3>📊 Fiyat Politika Geçmişi - {selectedVendor}</h3>

            {pricePolicies.length === 0 ? (
                <div className="empty-state">
                    <p>🤷‍♂️ Henüz uygulanmış bir fiyat politikası bulunmuyor.</p>
                </div>
            ) : (
                <div className="policies-list">
                    {pricePolicies.map(policy => (
                        <div key={policy.id} className={`policy-item ${policy.isActive ? 'active' : 'inactive'}`}>
                            <div className="policy-header">
                                <h4>{policy.policyName}</h4>
                                <span className={`policy-status ${policy.isActive ? 'active' : 'inactive'}`}>
                                    {policy.isActive ? '🟢 Aktif' : '🔴 Pasif'}
                                </span>
                            </div>

                            <div className="policy-details">
                                <div className="detail">
                                    <strong>Uygulandı:</strong> {new Date(policy.appliedAt).toLocaleDateString('tr-TR')}
                                </div>
                                <div className="detail">
                                    <strong>İşlem:</strong> %{policy.percentage} {policy.changeType === 'increase' ? 'Artış' : 'İndirim'}
                                </div>
                                <div className="detail">
                                    <strong>Tür:</strong> {policy.priceType === 'TEMPORARY' ? 'Geçici' : 'Kalıcı'}
                                </div>
                            </div>

                            {/* 🔥 YENİ: POLİTİKA KALDIRMA BUTONU */}
                            <div className="policy-actions">
                                {policy.isActive && (
                                    <button
                                        className="btn-warning"
                                        onClick={() => handleRemovePolicy(policy.id)}
                                    >
                                        🔄 Fiyatları Orijinaline Döndür
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    const renderProductSelection = () => (
        <div className="step-card">
            <div className="step-header">
                <div className="step-number">3</div>
                <div>
                    <h3>📦 {selectedVendor} - Ürünleri Seçin</h3>
                    <span className="vendor-subtitle">{selectedVendor} vendor'ına ait tüm ürünler</span>
                </div>
                <span className="product-count">
                    {vendorProducts.length} ürün
                </span>
            </div>

            {vendorProducts.length > 0 && (
                <>
                    <div className="product-selection-header">
                        <button
                            onClick={toggleSelectAll}
                            className={`btn-toggle ${selectedProducts.length === vendorProducts.length ? 'active' : ''}`}
                        >
                            {selectedProducts.length === vendorProducts.length ? '✅ Tümünü Kaldır' : '☑️ Tümünü Seç'}
                        </button>
                        <span className="selection-info">
                            {selectedProducts.length > 0
                                ? `✅ ${selectedProducts.length} ürün seçildi`
                                : 'ℹ️ Hiç ürün seçilmedi (tüm vendor ürünleri güncellenecek)'}
                        </span>
                    </div>

                    <div className="product-list">
                        {vendorProducts.map((product) => (
                            <div
                                key={product.id}
                                className={`product-item ${selectedProducts.includes(product.id) ? 'selected' : ''}`}
                                onClick={() => toggleProductSelection(product.id)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedProducts.includes(product.id)}
                                    onChange={() => toggleProductSelection(product.id)}
                                />
                                <div className="product-info">
                                    <div className="product-title">{product.title}</div>
                                    <div className="product-meta">
                                        {/* 🔥 ESTETİK FİYAT */}
                                        <span className="product-price">
                                            💰$ {product.variants?.[0]?.price || 'Fiyat Yok'}
                                        </span>
                                        <span className="product-separator">|</span>
                                        <span className="product-id">ID: {product.id}</span>
                                        <span className="product-separator">|</span>
                                        <span className="product-variants">{product.variants?.length || 0} variant</span>
                                    </div>
                                </div>
                                <div className={`product-status ${product.status}`}>
                                    {product.status}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <div className="step-actions">
                <button className="btn-secondary" onClick={prevStep}>
                    ⬅ Geri
                </button>
                <button
                    className="btn-primary"
                    onClick={() => nextStep('settings')}
                    disabled={vendorProducts.length === 0}
                >
                    Devam Et ➡
                </button>
            </div>
        </div>
    );

    const renderSettings = () => (
        <div className="step-card">
            <div className="step-header">
                <div className="step-number">4</div>
                <h3>⚙️ Ayarları Yapın</h3>
            </div>

            {priceUpdateType === 'temporary' ? (
                <div className="settings-grid">
                    <div className="form-group">
                        <label>Yüzde Değeri (%)</label>
                        <input
                            type="number"
                            value={percentage}
                            onChange={(e) => setPercentage(e.target.value)}
                            min="0.1"
                            max="1000"
                            step="0.1"
                            placeholder="10.5"
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>İşlem Türü</label>
                        <select
                            value={changeType}
                            onChange={(e) => setChangeType(e.target.value)}
                            className="form-select"
                        >
                            <option value="decrease">📉 Fiyat İndirimi</option>
                            <option value="increase">📈 Fiyat Artışı</option>
                        </select>
                    </div>

                    <div className="preview-card">
                        <h4>🎯 Ön İzleme</h4>
                        <div className="preview-content">
                            <strong>Örnek Hesaplama:</strong><br />
                            100₺ fiyat + %{percentage || '10'} {changeType === 'increase' ? 'artış' : 'indirim'} =
                            <span className="preview-result">
                                {changeType === 'increase'
                                    ? ` ${100 + (100 * (parseFloat(percentage) || 10) / 100)}₺`
                                    : ` ${100 - (100 * (parseFloat(percentage) || 10) / 100)}₺`
                                }
                            </span>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="settings-grid">
                    <div className="form-group full-width">
                        <label>Yeni Kalıcı Fiyat</label>
                        <input
                            type="number"
                            value={newPrice}
                            onChange={(e) => setNewPrice(e.target.value)}
                            min="0.01"
                            step="0.01"
                            placeholder="120.00"
                            className="form-input"
                        />
                        <div className="form-hint">
                            ⚠️ Bu işlem orijinal fiyatı kalıcı olarak değiştirecektir!
                        </div>
                    </div>
                </div>
            )}

            <div className="step-actions">
                <button className="btn-secondary" onClick={prevStep}>
                    ⬅ Geri
                </button>
                <button
                    className="btn-primary"
                    onClick={handleApplyChanges}
                    disabled={loading || (priceUpdateType === 'temporary' ? !percentage : !newPrice)}
                >
                    {loading ? '⏳ İşleniyor...' : '🚀 Değişiklikleri Uygula'}
                </button>
            </div>
        </div>
    );

    const renderResult = () => (
        <div className="step-card">
            <div className="step-header">
                <div className="step-number">5</div>
                <h3>{result?.success ? '✅ Tamamlandı!' : '❌ Hata!'}</h3>
            </div>

            <div className={`result-card ${result?.success ? 'success' : 'error'}`}>
                <h4>{result?.success ? 'Başarılı!' : 'Hata!'}</h4>
                <p>{result?.message}</p>

                {result?.success && (
                    <div className="result-details">
                        <div className="detail-item">
                            <strong>Vendor:</strong> {selectedVendor}
                        </div>
                        {priceUpdateType === 'temporary' && (
                            <div className="detail-item">
                                <strong>İşlem:</strong> %{percentage} {changeType === 'increase' ? 'artış' : 'indirim'}
                            </div>
                        )}
                        <div className="detail-item">
                            <strong>Ürün Sayısı:</strong> {selectedProducts.length > 0 ? selectedProducts.length : 'Tümü'} ürün
                        </div>
                    </div>
                )}
            </div>

            <div className="step-actions">
                {priceUpdateType === 'temporary' && result?.success && (
                    <button
                        className="btn-warning"
                        onClick={handleResetToOriginal}
                        disabled={loading}
                    >
                        {loading ? '⏳ İşleniyor...' : '🔄 Orijinal Fiyata Dön'}
                    </button>
                )}
                <button
                    className="btn-secondary"
                    onClick={() => {
                        setActiveSection('type');
                        setStepHistory(['type']);
                        setResult(null);
                    }}
                >
                    🔄 Yeni İşlem
                </button>
            </div>
        </div>
    );


    return (
        <div className="vendor-bulk-price-update">
            <div className="header">
                <h1>🏪 Toplu Fiyat Yönetimi</h1>

                {/* 🔥 YENİ: SEKMELER */}
                <div className="tabs">
                    <button
                        className={`tab ${activeTab === 'new' ? 'active' : ''}`}
                        onClick={() => setActiveTab('new')}
                    >
                        🎯 Yeni İşlem
                    </button>
                    <button
                        className={`tab ${activeTab === 'history' ? 'active' : ''}`}
                        onClick={() => setActiveTab('history')}
                        disabled={!selectedVendor}
                    >
                        📊 Politika Geçmişi
                    </button>
                </div>

                {/* Progress Steps (sadece yeni işlemde göster) */}
                {activeTab === 'new' && (
                    <div className="progress-steps">
                        {['type', 'vendor', 'products', 'settings', 'result'].map((step, index) => (
                            <div
                                key={step}
                                className={`progress-step ${stepHistory.includes(step) ? 'completed' : ''} ${activeSection === step ? 'active' : ''}`}
                            >
                                <div className="step-dot">{index + 1}</div>
                                <span className="step-label">
                                    {step === 'type' && 'Tür'}
                                    {step === 'vendor' && 'Vendor'}
                                    {step === 'products' && 'Ürünler'}
                                    {step === 'settings' && 'Ayarlar'}
                                    {step === 'result' && 'Sonuç'}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="content">
                {activeTab === 'new' ? (
                    /* MEVCUT ADIMLAR */
                    <>
                        {activeSection === 'type' && renderTypeSelection()}
                        {activeSection === 'vendor' && renderVendorSelection()}
                        {activeSection === 'products' && renderProductSelection()}
                        {activeSection === 'settings' && renderSettings()}
                        {activeSection === 'result' && renderResult()}
                    </>
                ) : (
                    /* 🔥 YENİ: POLİTİKA GEÇMİŞİ */
                    renderPolicyHistory()
                )}
            </div>
        </div>

    );

};
export default VendorBulkPriceUpdate;